import { render, staticRenderFns } from "./RendPositionsTp.vue?vue&type=template&id=1f91d596&"
import script from "./RendPositionsTp.vue?vue&type=script&lang=js&"
export * from "./RendPositionsTp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports